import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { QueryClient, QueryOptions } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';

import { onAccessTokenChange } from '@/lib/tokenStorage';
import { accessTokenQueryOptions } from '@/services/auth';

type Meta = {
  persist?: boolean;
};

declare module '@tanstack/react-query' {
  interface Register {
    queryMeta: Meta;
  }
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000, // 30 seconds
      gcTime: 1000 * 60 * 60 * 48, // 48 hours
    },
  },
});

const stopTabSync = onAccessTokenChange(async (token) => {
  const { queryKey } = accessTokenQueryOptions();
  if (token) {
    await queryClient.cancelQueries({ queryKey });
  }
  queryClient.setQueryData(queryKey, token);
});

import.meta.hot?.dispose(stopTabSync);

const localStoragePersister = createAsyncStoragePersister({
  storage: window.localStorage,
});

persistQueryClient({
  queryClient,
  persister: localStoragePersister,
  dehydrateOptions: {
    // Only persist queries that have `meta.persist` set to true
    shouldDehydrateQuery(query: QueryOptions) {
      return !!query.meta?.persist;
    },
    // Don't persist mutations
    shouldDehydrateMutation: () => false,
  },
});
